module.exports = __webpack_public_path__ + "img/pijltje-wit-links.1a931e57280ba6d04bc8c0dd909b44eb.svg";